import { render, staticRenderFns } from "./DeleteRequest.vue?vue&type=template&id=fcd87f4a&"
import script from "./DeleteRequest.vue?vue&type=script&lang=js&"
export * from "./DeleteRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports